import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  /** Faixa horizontal, sem o respiro de uma tela vazia. */
  compact?: boolean;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  compact = false,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 px-6 py-16 text-center',
        compact && 'flex-row items-center justify-start gap-3 px-4 py-3.5 text-left sm:px-5',
        className,
      )}
    >
      <span
        className={cn(
          'grid shrink-0 place-items-center bg-primary/10 text-primary',
          compact ? 'size-9 rounded-xl' : 'size-14 rounded-2xl',
        )}
      >
        <Icon className={compact ? 'size-4' : 'size-7'} />
      </span>
      <div className={cn('min-w-0', compact ? 'flex-1' : 'max-w-sm')}>
        <h3 className={cn('font-semibold', compact ? 'text-sm' : 'text-base')}>{title}</h3>
        {description ? (
          <p className={cn('text-sm text-muted-foreground', compact ? 'mt-0.5' : 'mt-1')}>
            {description}
          </p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
